<template>
  <div id="auth_signup" class="columns column">
    <div class="column combo_1 p0">
      <div class="form_container combo_1">
        <div class="language-bar">
          <base-language-bar></base-language-bar>
        </div>

        <img
          class="'mw100 auth_logo combo_1'"
          src="../../assets/images/stratumblue_white_outline_logo.png"
        />

        <div class="blu-prices">
          <blu-prices-header></blu-prices-header>
        </div>

        <div class="page_banner_countdown">
          <div class="clock" v-if="countdownInterval">
            <div>
              <span class="days">{{ clock.days }}</span>
              <div class="smalltext">{{ $t("msg.days") }}</div>
            </div>
            <div>
              <span class="hours">{{ clock.hours }}</span>
              <div class="smalltext">{{ $t("msg.hours") }}</div>
            </div>
            <div>
              <span class="minutes">{{ clock.minutes }}</span>
              <div class="smalltext">{{ $t("msg.minutes") }}</div>
            </div>
            <div>
              <span class="seconds">{{ clock.seconds }}</span>
              <div class="smalltext">{{ $t("msg.seconds") }}</div>
            </div>
          </div>
        </div>

        <div class="combo_1" style="position: relative">
          <label>{{ $t("msg.country_residency") }}</label>
          <VuePhoneNumberInput
            class="VuePhoneNumberInput"
            v-model="signupform.phone"
            :border-radius="6"
            :translations="{
              countrySelectorLabel: $t('msg.phone_code'),
              phoneNumberLabel: $t('msg.phone_optional'),
            }"
            color="#333364"
            @update="verifyCountry($event)"
            @keyup="onChangeRemoveError(signupform, 'phone')"
            :error="countriesNotAllowed"
            :no-example="countriesNotAllowed"
          />

          <span
            class="help is-danger"
            v-show="hasError.phone && !countriesNotAllowed"
            >{{ $t(`msg.${errorMsg.phone}`) }}</span
          >

          <span class="help is-danger" v-show="countriesNotAllowed">{{
            $t("msg.invalid_phone_country")
          }}</span>
        </div>

        <div class="combo_1" style="position: relative">
          <div style="display: flex; align-items: center">
            <label>{{ $t("msg.email") }}</label>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tooltip_disclaimer_new"
              @mouseover="showInfo['1a'] = true"
              @mouseleave="showInfo['1a'] = false"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <input
            class="input_write_form"
            type="text"
            id="email"
            :style="errorInputStyle.email"
            placeholder="Email*"
            @keyup="onChangeRemoveError(signupform, 'email')"
            v-model="signupform.email"
          />

          <span class="help is-danger" v-show="hasError.email">
            {{ $t(`msg.${errorMsg.email}`) }}</span
          >

          <transition name="bounce">
            <div
              v-if="showInfo['1a']"
              class="info"
              v-html="$t('msg.create_new_email_recommendation')"
            />
          </transition>
        </div>

        <div class="combo_1">
          <div style="display: flex; align-items: center">
            <label>{{ $t("msg.password") }}</label>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tooltip_disclaimer_new"
              @mouseover="showInfo['1b'] = true"
              @mouseleave="showInfo['1b'] = false"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <input
            class="input_write_form"
            type="password"
            :style="errorInputStyle.password"
            :placeholder="$t('msg.password_create') + '*'"
            v-model="signupform.password"
            @keyup="onChangeRemoveError(signupform, 'password'), toggleRemove()"
            @focus="toggleBox()"
          />

          <span class="help is-danger" v-show="hasError.password">
            {{ $tc(`msg.${errorMsg.password}`, 1) }}
          </span>

          <div
            class="suggestion-box text_sm"
            v-if="showBox"
            :class="slide ? 'slideOutUp' : ''"
          >
            <div class="content_lock">
              <i v-html="iconSets.lock_icon_fit" class="icon_class_06"></i>
            </div>
            <div class="w100 p5_r">
              <div class="justify_between_ai_center">
                {{ $tc("msg.password_suggestion") }}
              </div>
              <div class="justify_between_ai_center suggestion_input">
                <span @click="usePasswordSujest()" class="pointer">{{
                  passwordSujest
                }}</span>
                <i
                  v-html="iconSets.refresh_fit"
                  class="icon_class_1"
                  @click="generate(), (roll = true)"
                  :class="roll ? 'rool' : ''"
                ></i>
              </div>
            </div>
          </div>

          <transition name="bounce">
            <div
              class="info"
              v-if="showInfo['1b']"
              v-html="$tc(`msg.password_requirements`, 1)"
            />
          </transition>
        </div>

        <div class="combo_1">
          <label>{{ $t("msg.confirm_password") }}</label>
          <input
            class="input_write_form"
            type="password"
            :style="errorInputStyle.passwordConfirmation"
            :placeholder="$t('msg.confirm_password') + '*'"
            v-model="signupform.passwordConfirmation"
            @keyup="onChangeRemoveError(signupform, 'passwordConfirmation')"
          />
          <span class="help is-danger" v-show="hasError.passwordConfirmation">{{
            $tc(`msg.${errorMsg.passwordConfirmation}`, 1)
          }}</span>
        </div>

        <div class="combo_1" style="position: relative">
          <div style="display: flex; align-items: center">
            <label>{{ $t("msg.did_someone_referred") }}</label>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tooltip_disclaimer_new"
              @mouseover="showInfo['1c'] = true"
              @mouseleave="showInfo['1c'] = false"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <input
            class="input_write_form"
            type="referral_code"
            :placeholder="$t('msg.referral_code')"
            :style="errorInputStyle.referralCode"
            v-model="signupform.referralCode"
            :readonly="referCode != ''"
            @keyup="onChangeRemoveError(signupform, 'referralCode')"
          />
          <span class="help is-danger" v-show="hasError.referralCode">{{
            $tc(`msg.${errorMsg.referralCode}`, 1)
          }}</span>

          <transition name="bounce">
            <div
              class="info"
              v-if="showInfo['1c']"
              v-html="$t('msg.was_referred')"
            />
            
          </transition>
        </div>

        <div
          class="form_block combo_1 form_block_checkbox"
          style="width: 100% !important; align-items: center !important"
        >
          <label class="combo_1 label_box">
            <input
              type="checkbox"
              v-model="signupform.hasAcceptedTerms"
              @change="onChangeRemoveError(signupform, 'hasAcceptedTerms')"
            />
            <span
              class="control-label"
              :style="!checkBoxTerms ? 'border: 1px solid darkgrey;' : ''"
            ></span>
          </label>

          <p
            class="label_text"
            @click="(e) => openCheckBox(e, 'checkBoxTerms')"
            v-html="$t('msg.i_read_and_accept')"
            style="font-size: 14px !important"
          ></p>

          <span class="help is-danger" v-show="hasError.hasAcceptedTerms">{{
            $tc(`msg.${errorMsg.hasAcceptedTerms}`, 1)
          }}</span>
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 25px;
            margin-bottom: 25px;
          "
        >
          <vue-recaptcha
            ref="recaptcha"
            sitekey="6Ld5qccaAAAAAH5xmkU8cw9CA1UwtP66KcL-UP2f"
            :loadRecaptchaScript="true"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
          ></vue-recaptcha>
        </div>

        <div class="combo_1" style="z-index: 10 !important; margin-top: 70px;">
          <base-loading v-if="loading" class="regular_submit"></base-loading>

          <button v-else type="submit" @click="submitSignup">
            {{ $t("msg.signup") }}
          </button>
        </div>

        <span class="help is-danger" v-show="hasError.formSent">
          {{ $t(`msg.${errorMsg.formSent}`, 1) }}
        </span>

        <span class="help is-success" v-show="hasSuccess.formSent">
          {{ $t(`msg.${successMsg.formSent}`, 1) }}
        </span>

        <div class="not_member_yet">
          <router-link :to="{ name: 'login' }" exact>
            <a>
              <span class="fat">{{ $t("msg.login_here") }}</span>
            </a>
          </router-link>
        </div>
      </div>
    </div>
    <div class="column tal_c" v-if="isMobile">
      <phases></phases>
    </div>
  </div>
</template>

<script>
import BaseLoading from "../../components/public/BaseLoading";
import BaseWrittenLogo from "../../components/public/BaseWrittenLogo";
import VueRecaptcha from "vue-recaptcha";
import BaseLanguageBar from "../../components/public/BaseLanguageBar";
import BluPricesHeader from "../../components/public/BluPricesHeader";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { mapGetters } from "vuex";

function SignupFields() {
  // this.name = "";
  this.phone = "";
  this.email = "";
  this.password = "";
  this.passwordConfirmation = "";
  this.referralCode = "";
  this.language = "EN";
  this.isNotChinaCitizen = true;
  this.isNotUsaCitizen = true;
  this.hasAcceptedTerms = "";
  this.hasAcceptedPrivacyPolicy = true;
  this.formSent = "";
}

export default {
  name: "signup",
  created() {
    window.addEventListener("resize", this.checkIfMobile);
    this.setCountdown();
    this.generate();
    setTimeout(() => {
      this.$router.push({ name: "login" });
    }, 1000)
  },
  mounted() {
    this.setValidationFields(SignupFields);
    this.signupform.referralCode = this.referCode;
    this.checkIfMobile();
  },
  props: {
    referCode: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    results: "",
    countriesNotAllowed: false,
    checkBoxTerms: false,
    checkBoxPrivacy: false,
    recaptchaToken: "",
    loading: false,
    signupform: new SignupFields(),
    receiveCodeBtnClicked: false,
    receiveCodeCounter: 0,
    isCodeAdded: false,
    isMobile: false,
    passwordSujest: "",
    showBox: false,
    roll: false,
    slide: false,
    size: "17",
    characters: "a-z,A-Z,0-9,#",
    buttonOff: true,
    deadline: "April 6 2019 0:00:00 GMT-0200",
    remainingTime: "",
    countdownInterval: "",
    clock: {
      days: "",
      hours: "",
      minutes: "",
      seconds: "",
      status: "",
    },
    showInfo: {
      "1a": false,
      "1b": false,
      "1c": false,
    },
    terms: false,
    privacy: false,
  }),
  methods: {
    openCheckBox(e, el) {
      const eventHref = e.path[0].href;

      if (eventHref.includes("terms")) {
        this.terms = true;
      }

      if (eventHref.includes("privacy")) {
        this.privacy = true;
      }

      if (this.terms && this.privacy) {
        this[el] = true;
      }
    },

    verifyCountry($event) {
      this.results = $event.countryCode;

      if (
        this.results == "CN" ||
        this.results == "HK" ||
        this.results == "US"
      ) {
        this.countriesNotAllowed = true;
      } else {
        this.countriesNotAllowed = false;
      }
    },

    toggleBox() {
      if (!this.signupform.password) {
        this.slide = false;
        this.showBox = true;
      }
    },

    onCaptchaVerified: function (recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },

    onCaptchaExpired: function () {
      this.recaptchaToken = "";
      this.$refs.recaptcha.reset();
    },

    toggleRemove() {
      this.slide = true;
    },

    generate() {
      let CharacterSet =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789![]{}()%&*$#^<>~@|";
      let password = "";

      for (let i = 0; i < this.size; i++) {
        password += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      this.passwordSujest = password;
    },

    usePasswordSujest() {
      this.signupform.password = this.passwordSujest;
      this.signupform.passwordConfirmation = this.passwordSujest;
    },

    setCountdown() {
      let time = Date.parse(this.deadline) - Date.parse(new Date());
      this.remainingTime = time;

      if (time > 0) {
        this.clock.days = Math.floor(time / (1000 * 60 * 60 * 24));
        this.clock.hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        this.clock.minutes = Math.floor((time / 1000 / 60) % 60);
        this.clock.seconds = Math.floor((time / 1000) % 60);
        this.setUpdateCountdown();
      }
    },
    setUpdateCountdown() {
      let time = Date.parse(this.deadline) - Date.parse(new Date());
      this.remainingTime = time;
      if (time > 0) {
        this.countdownInterval = setInterval(this.updateCountdown, 1000);
      } else {
      }
    },
    updateCountdown() {
      let time = Date.parse(this.deadline) - Date.parse(new Date());
      if (time > 0) {
        this.clock.days = Math.floor(time / (1000 * 60 * 60 * 24));
        this.clock.hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        this.clock.minutes = Math.floor((time / 1000 / 60) % 60);
        this.clock.seconds = Math.floor((time / 1000) % 60);
      } else {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },

    checkIfMobile() {
      if (window.innerWidth > 767) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },

    validatePhone(phone) {
      return phone && phone.length > 0 && !this.countriesNotAllowed;
    },

    submitSignup() {
      const form = this.signupform;
      this.showOrHideError("phone", this.validatePhone(form.phone));
      this.showOrHideError("email", this.validateEmail(form.email));
      this.showOrHideError("password", this.validatePassword(form.password));
      this.showOrHideError(
        "passwordConfirmation",
        form.passwordConfirmation && form.passwordConfirmation === form.password
      );
      this.showOrHideError(
        "referralCode",
        form.referralCode === "" || form.referralCode.length === 8
      );
      this.showOrHideError("isNotUsaCitizen", true);
      this.showOrHideError("isNotChinaCitizen", true);
      this.showOrHideError("hasAcceptedTerms", form.hasAcceptedTerms);
      this.showOrHideError("hasAcceptedPrivacyPolicy", true);

      const formPayload = {
        // name: form.name,
        phone: form.phone,
        email: form.email,
        password: form.password,
        passwordConfirmation: form.passwordConfirmation,
        referCode: form.referralCode,
        language: form.language,
        optinUSA: form.isNotUsaCitizen,
        optinCN: form.isNotChinaCitizen,
        optinPrivacy: form.hasAcceptedPrivacyPolicy,
        optinTerms: form.hasAcceptedTerms,
        recaptchaToken: this.recaptchaToken,
      };

      if (this.buttonOff) {
        this.notifyDanger(this.$t("msg.confirm_recaptcha"), 5000);
      } else {
        this.checkIfFormHasErrorsAndSubmit(
          formPayload,
          this.postSignupForm,
          this.afterSubmitSuccess,
          this.afterSubmitError
        );
      }
    },
    postSignupForm(form) {
      return this.$store.dispatch("postSignup", form);
    },
    afterSubmitSuccess() {
      this.loading = false;
      this.notifyDefault(
        this.$t("msg.check_your_email"),
        "alert_success",
        5000
      );
      this.$router.push("login");
    },
    afterSubmitError(error) {
      this.loading = false;
      this.notifyError(error);
    },
  },
  components: {
    BaseLoading,
    BaseWrittenLogo,
    VuePhoneNumberInput,
    VueRecaptcha,
    BaseLanguageBar,
    BluPricesHeader,
  },
  computed: {
    ...mapGetters(["currencies"]),
  },

  watch: {
    roll: function () {
      setTimeout(() => {
        this.roll = false;
      }, 3000);
    },

    recaptchaToken: function () {
      if (this.recaptchaToken == "") {
        this.buttonOff = true;
      } else {
        this.buttonOff = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/public/Signup.vue